/*
* @描述: 订单后台管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-20 16:16:36
*/
<template>
    <div class="page_container">
        <el-tabs v-model="tabActiveName" class="list_page_tabs" @tab-click="handleClickTab">
            <el-tab-pane label="表单配置" name="form_site">
                <CustomFormSite ref="customFormSite"
                                :can_set_show_rules="true"
                                :field_form="'orders'"
                                :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置'"
                                :field_form_title="'新增订单表单预览区'"
                                :is_form_module="true"
                                :publish_btn_show="true"
                                :review_btn_show="true"
                                :review_form_type_list="reviewFormTypeList"
                                :review_dialog_width="'1120px'"
                                is_two_column
                                @submit-fields="submitFields"/>
            </el-tab-pane>
            <el-tab-pane label="审批设置" name="approve_site">
                <div class="el_tab_pane_wrap">
                    <div class="approve_site_hint_wrap">
                        <span>开关开启，该业务操作需进行审批，具体审批流程请前往</span>
                        <el-link :underline="false" type="primary" @click="handleClickToApprovalBackendManagement">
                            审批->后台管理
                        </el-link>
                        <span>中配置</span>
                    </div>
                    <vxe-table :data="approveSiteData" border round>
                        <vxe-column field="name" title="业务名称"></vxe-column>
                        <vxe-column field="is_approve"
                                    title="是否需要审批"
                                    width="156">
                            <template #default="{ row }">
                                <el-switch v-model="row.is_approval"
                                           :active-value="1"
                                           :inactive-value="0"
                                           @change="handleIsApprovalChange(row)"></el-switch>
                            </template>
                        </vxe-column>
                        <vxe-column title="操作" width="80">
                            <template #default="{ row }">
                                <el-link :underline="false" type="primary" @click="handleClickApproveSetting(row)">
                                    前往设置
                                </el-link>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import CustomFormSite from "@/components/pComponents/CustomFormSite";
import {approvalBusinessIsApprovalSet, approvalBusinessSetList} from "@/api";

export default {
    name: "OrderManagement",
    data() {
        return {
            tabActiveName: 'form_site',
            reviewFormTypeList: [
                {
                    title: "电脑端",
                    value: "pc",
                    form_title: "新增订单",
                    form_desc: "模拟真实新增商机页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
                {
                    title: "移动端",
                    value: "mobile",
                    form_title: "新增订单",
                    form_desc: "模拟真实新增商机页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                },
            ],
            submitFlag: false,
            approveSiteData: []
        }
    },
    components: {CustomFormSite},
    mounted() {
    },
    methods: {
        handleClickTab(tab) {
            if (this.tabActiveName === 'approve_site') {
                this.getApprovalSetList()
            }
        },

        submitFields(data) {
            this.submitFlag = false;
            if (data && data.field_list) {
                this.submitFlag = true;
            }
            this.fieldsData = data;
        },

        //获取审批设置列表
        getApprovalSetList() {
            approvalBusinessSetList({
                business_type: 'order'
            }).then(res => {
                if (res.code === 200) {
                    this.approveSiteData = res.data
                } else {
                    this.$message.error(res.message)
                }
            }).catch(res => {
                this.$message.error(res.message)
            })
        },

        //点击前往审批后台设置
        handleClickToApprovalBackendManagement() {
            this.$router.push({
                name: "approveAdminManagement",
                params: {
                    isPush: true,
                },
                query: {
                    name: '后台设置-审批',
                },
            })
        },

        //是否需要审批切换事件
        handleIsApprovalChange(row) {
            approvalBusinessIsApprovalSet({
                approval_business_set_id: row.approval_business_set_id
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('设置成功')
                    this.getApprovalSetList()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => {

            })
        },

        //前往审批设置
        handleClickApproveSetting(row) {
            this.$router.push({
                name: 'approveAdminSettings',
                query: {
                    id: row.approval_type_id,
                    name: row.name
                },
                params: {
                    isPush: true,
                },
            })
        },
    },
}
</script>
<style lang="scss" scoped>
</style>